module.exports = __webpack_public_path__ + "static/flags/VE-1605691f81796fa7144b20961ecc41d6.gif";